import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FooterSection = () => {
  const navigate = useNavigate();
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: 'Expert Marketplace', action: () => navigate('/expert-marketplace-listing') },
      { label: 'Blog', action: () => navigate('/blog') },
    ],
    company: [
      { label: 'About', action: () => navigate('/about') },
      { label: 'Contact', action: () => navigate('/contact') },
      { label: 'Support', action: () => navigate('/contact') }, // Support routes to Contact
    ],
    legal: [
      { label: 'Terms of Use', action: () => navigate('/terms-of-service') },
      { label: 'Privacy Policy', action: () => navigate('/privacy-policy') },
      { label: 'Refund Policy', action: () => navigate('/refund-policy') },
      { label: 'Report Disclaimer', action: () => navigate('/report-disclaimer') },
    ],

  };

  const socialLinks = [
    { icon: 'Twitter',   label: 'X / Twitter', url: 'https://x.com/FireCaseIQ' },
    { icon: 'Facebook',  label: 'Facebook',    url: 'https://www.facebook.com/profile.php?id=61586913364477' },
    { icon: 'Linkedin',  label: 'LinkedIn',    url: 'https://www.linkedin.com/company/111916011/' },
    { icon: 'Instagram', label: 'Instagram',   url: 'https://www.instagram.com/firecaseiq/' },
    { icon: 'Mail',      label: 'Email',        url: 'mailto:info@firecaseiq.com' },
  ];

  return (
    <footer className="bg-card border-t border-border py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 md:gap-12 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <img src="/assets/images/logo.png" alt="FireCaseIQ" className="h-10 object-contain" />
            </div>

            <p className="text-sm text-muted-foreground mb-6 max-w-sm">
              AI-assisted preliminary fire case analysis. Upload your materials once, answer clarifying questions, and receive
              a structured report with annotated images—plus the option to hire a vetted human expert.
            </p>

            <div className="mb-6">
              <p className="text-sm text-muted-foreground">
                <strong>Filmology LLC d/b/a Grunt Logic</strong><br />
                5448 Apex Peakway Suite 157<br />
                Apex NC 27502
              </p>
              <p className="text-sm text-muted-foreground mt-2">
                Email: <a href="mailto:info@firecaseiq.com" className="text-primary hover:underline">info@firecaseiq.com</a><br />
                Enterprise: <a href="mailto:sales@firecaseiq.com" className="text-primary hover:underline">sales@firecaseiq.com</a>
              </p>
            </div>

            <div className="flex items-center gap-4">
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.url}
                  aria-label={social?.label}
                  className="w-10 h-10 rounded-lg bg-muted hover:bg-primary hover:text-primary-foreground transition-smooth flex items-center justify-center"
                >
                  <Icon name={social?.icon} size={20} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Product</h4>
            <ul className="space-y-3">
              {footerLinks?.product?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={link?.action}
                    className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={link?.action}
                    className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={link?.action}
                    className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              © {currentYear} FireCaseIQ. All rights reserved.
            </p>

            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2">
                <Icon name="Lock" size={16} className="text-success" />
                <span className="text-sm text-muted-foreground">Encrypted by design</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={16} className="text-success" />
                <span className="text-sm text-muted-foreground">Security-first access</span>
              </div>
            </div>
          </div>

          <p className="mt-3 text-xs text-muted-foreground text-center md:text-left">
            AI-generated outputs are preliminary and informational. Not legal advice. Not a substitute for a licensed on-site investigation.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
